import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { styled, globalCss } from "@stitches/react";
import { useAppState } from "@/contexts/app-state";
import AscensionHeader from "@components/AscensionHeader";
import Loader from "@components/Loader";
import ContextOutputSwitch from "./components/Contextoutputswitch";

const globalStyles = globalCss({
  ".fe_f_all .fe_c_multiselect__control": {
    whiteSpace: "nowrap",
  },
  ".fe_f_all .fe_c_multiselect__menu": {
    minWidth: 200,
  },
});

const Content = styled("div", {
  display: "flex",
  flexDirection: "column",
});

function App() {
  const { isFetchingContext, context, authorizationError } = useAppState();
  const location = useLocation();
  const navigate = useNavigate();
  globalStyles();

  useEffect(() => {
    if (location.pathname === "/" && context)
      navigate("/my-tasks", { replace: true });
  });

  return (
    <div className="App">
      <AscensionHeader text="Radiology AuthConnect" />
      <Content>
        <Loader
          isLoading={isFetchingContext}
          displayText="Authorizing Application Access"
        >
          <ContextOutputSwitch
            authorizationError={authorizationError}
            context={context}
          />
        </Loader>
      </Content>
    </div>
  );
}
export default App;
